module.exports = __webpack_public_path__ + "static/5-before.1bce3906.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/5-before.jpg
// module id = 428
// module chunks = 221374088121123